export default __webpack_public_path__ + "static/media/ff-logo.9f9f2a0d.jpg";